import React from 'react'
import HeroContact from '../Component/Contacts/HeroContact'
import Contact from '../Component/Contacts/Contact'
import ContactInfo from '../Component/Contacts/ContactInfo'

const MyContact = () => {
    return (
        <div>
            <HeroContact/>
            <Contact/>
            <ContactInfo/>
            
            
        </div>
    )
}

export default MyContact
